module.exports = __webpack_public_path__ + "img/bg-flecha-atras.ff4cc8fb.png";